import { render, staticRenderFns } from "./SpeedDialCorpsDetail.vue?vue&type=template&id=bd9546ea"
import script from "./SpeedDialCorpsDetail.vue?vue&type=script&lang=ts"
export * from "./SpeedDialCorpsDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports